/* unplugin-vue-components disabled */import { render } from "./zoushi.vue?vue&type=template&id=0cadc4bd&scoped=true"
import script from "./zoushi.vue?vue&type=script&lang=js"
export * from "./zoushi.vue?vue&type=script&lang=js"

import "./zoushi.vue?vue&type=style&index=0&id=0cadc4bd&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cadc4bd"]])

export default __exports__